/**
 * O componente recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */

const $el = $(el);
const $slider = $('.wrap-cards');

if (Is.mobile.ANY()) {
    $slider.each(function(idx, elm) {
        const $elm = $(elm);
        const totalItens = $elm.find('[data-component="blocks/card-product"]').length;

        if(totalItens > 1) {
            const $parent     = $elm.parents('.product-type');
            const $prev       = $parent.find('.slick-prev');
            const $next       = $parent.find('.slick-next');
            const $sliderDots = $parent.find('.slider-dots');

            $elm.slick({
                mobileFirst: true,
                slidesToScroll: 1,
                slidesToShow: 1,
                infinite: false,
                arrows: true,
                dots: true,
                prevArrow: $prev,
                nextArrow: $next,
                appendDots: $sliderDots,
                responsive: [
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        }
                    },
                    {
                        breakpoint: 1024,
                        settings: "unslick"
                    },
                ]
            });
        }
    });
}
